import i18n from "../../plugins/I18nPlugin";

/**
 * Validates a BIC (SWIFT) code
 * @param message - i18n key for error message
 */
export function bicRule(message = "report.thgContactData.noValidBic"): (value: string) => boolean | string {
  return (value) => validBicFormat(value) || String(i18n.tc(message));
}

/**
 * Checks if a BIC is correctly formatted
 * @param bic
 */
export function validBicFormat(bic: string): boolean {
  // BIC format: 8 or 11 characters, uppercase letters and digits
  // 4 letters (bank code), 2 letters (country code), 2 letters or digits (location code), optional 3 letters or digits (branch code)
  const bicRegex = /^[A-Z]{4}[A-Z]{2}[A-Z0-9]{2}([A-Z0-9]{3})?$/;
  return bicRegex.test(bic);
}
